/**
 * Import required libraries
 */
import React, { useState, useRef } from "react";
import { connect } from "react-redux";

/**
 * Import required elements
 */
import LanguageRender from "./render";

/**
 * Language Component
 */
function Language(props) {
  const [menuIsOpen, openMenu] = useState(false);

  const setLanguage = language => event => {
    props.dispatch({
      type: "SET_LANGUAGE",
      language
    });
    openMenu(false);
  };

  const handleOpen = event => openMenu(prev => !prev);
  const handleClose = event => openMenu(false);

  const { lang } = props;
  const buttonRef = useRef();

  return React.createElement(LanguageRender, {
    lang,
    setLanguage,
    handleOpen,
    handleClose,
    menuIsOpen,
    buttonRef
  });
}

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  lang: state.locale.lang
}))(Language);
